var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPeopleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0M10.5 5a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11M21 12a2 2 0 1 1 4 0a2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8a4 4 0 0 0 0-8M2 21a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v.226a3 3 0 0 1-.02.279c-.02.173-.057.408-.13.686a5.6 5.6 0 0 1-.999 2.017C16.681 25.71 14.48 27 10.5 27s-6.18-1.29-7.351-2.792a5.6 5.6 0 0 1-1-2.017a5 5 0 0 1-.146-.898l-.002-.067v-.023L2 21.195zm2 .178v.012q0 .026.009.094c.01.09.031.23.076.404c.09.348.273.818.641 1.291C5.431 23.883 6.98 25 10.5 25s5.07-1.117 5.774-2.02a3.6 3.6 0 0 0 .64-1.292A3 3 0 0 0 17 21.19l.001-.012V21a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm15.477 3.314c.93.316 2.087.508 3.523.508c3.201 0 5.02-.953 6.013-2.125c.483-.57.73-1.148.855-1.592a3.7 3.7 0 0 0 .129-.729l.001-.036l.001-.022v-.038A2.457 2.457 0 0 0 27.542 18h-8.189c.5.559.863 1.243 1.035 2h7.154c.25 0 .452.199.458.446l-.004.044a2 2 0 0 1-.052.25c-.062.22-.19.528-.457.843C26.98 22.182 25.799 23 23 23c-1.165 0-2.049-.142-2.721-.35a7 7 0 0 1-.802 1.842",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.65,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPeopleOutlined);
export default __webpack_public_path__ + "static/media/team_people_outlined.dd5be80cfe0d9809e19d3d2e0bea1c95.svg";
export { ForwardRef as ReactComponent };